import config from '../../../../config';

export default function getIdentityUrl() {
  return new URL(String(config.identityEndpoint));
}
